import { render, staticRenderFns } from "./EnablingFormTab.vue?vue&type=template&id=01773156"
import script from "./EnablingFormTab.vue?vue&type=script&lang=js"
export * from "./EnablingFormTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports